/**
 * FlyFreely API
 *
 * Contact: support@flyfreely.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface RpaCategoryGroup {
    /**
     * if present, the list of RPA that the status applies to
     */
    rpaIdList?: Array<number>;
    /**
     * The status for this combination of RPA
     */
    registerStatus: RpaCategoryGroup.RegisterStatus;
    /**
     * The status calculation source. Either AUTO or an override status.
     */
    registerStatusSource: RpaCategoryGroup.RegisterStatusSource;
    /**
     * What is the overall result of the register check
     */
    enforcementOutcome: RpaCategoryGroup.EnforcementOutcome;
}
export namespace RpaCategoryGroup {
    export type RegisterStatus =
        | 'PENDING'
        | 'ACTIVE'
        | 'SUSPENDED'
        | 'EXPIRED'
        | 'NOT_ON_REGISTER'
        | 'NOT_AVAILABLE'
        | 'REGISTER_DISABLED';
    export const RegisterStatus = {
        PENDING: 'PENDING' as RegisterStatus,
        ACTIVE: 'ACTIVE' as RegisterStatus,
        SUSPENDED: 'SUSPENDED' as RegisterStatus,
        EXPIRED: 'EXPIRED' as RegisterStatus,
        NOT_ON_REGISTER: 'NOT_ON_REGISTER' as RegisterStatus,
        NOT_AVAILABLE: 'NOT_AVAILABLE' as RegisterStatus,
        REGISTER_DISABLED: 'REGISTER_DISABLED' as RegisterStatus
    };
    export type RegisterStatusSource =
        | 'NOMINATED'
        | 'PENDING'
        | 'ACTIVE'
        | 'SUSPENDED'
        | 'AUTO'
        | 'NOT_ON_REGISTER';
    export const RegisterStatusSource = {
        NOMINATED: 'NOMINATED' as RegisterStatusSource,
        PENDING: 'PENDING' as RegisterStatusSource,
        ACTIVE: 'ACTIVE' as RegisterStatusSource,
        SUSPENDED: 'SUSPENDED' as RegisterStatusSource,
        AUTO: 'AUTO' as RegisterStatusSource,
        NOT_ON_REGISTER: 'NOT_ON_REGISTER' as RegisterStatusSource
    };
    export type EnforcementOutcome = 'PASS' | 'ADVISE' | 'BLOCK';
    export const EnforcementOutcome = {
        PASS: 'PASS' as EnforcementOutcome,
        ADVISE: 'ADVISE' as EnforcementOutcome,
        BLOCK: 'BLOCK' as EnforcementOutcome
    };
}
